import useReduxCase from './useCurrentCaseStore';

const useCaseStatus = () => {
  const currentCaseStore = useReduxCase();
  const currentCaseData = currentCaseStore.data as NonNullable<typeof currentCaseStore.data>;
  return currentCaseData.case.status;
};

export default useCaseStatus;
